import type { OfferType } from '@/types/BrandOffer.types';
import type { OfferTypeSpec } from './OfferProductPreview.types';

export const OFFER_PREVIEW_BASE_PRODUCT = {
  id: 1548942,
  name: 'Ruffle Placket Blouse',
  brandName: 'Savana',
  marketplace: 'Savana',
  imageUrl:
    'https://d19dlu1w9mnmln.cloudfront.net/b_1770727395725066_795bf9ea2146',
  brandLogoUrl: 'https://d19dlu1w9mnmln.cloudfront.net/logos/Savana.JPG',
  price: 792,
  discountPrice: 792,
} as const;

export const DAY_MS = 24 * 60 * 60 * 1000;

export const OFFER_PREVIEW_FALLBACK_IMAGE = '/images/category/all_pro.webp';

export const OFFER_PREVIEW_RATING_BADGE = '4.1 ★ | 6';

export const SALE_PILL_LABELS = {
  paused: 'Paused',
  saleEnded: 'Sale ended',
  setEndTime: 'Set end time',
  saleLive: 'Sale live',
} as const;

export const OFFER_BANNER_COPY = {
  getAtPrefix: 'Get at',
  bestPriceCaption: 'BEST PRICE',
  addTiersCaption: 'Add tiers to preview',
  offerFallback: 'OFFER',
} as const;

export const OFFER_TYPE_SPEC: Record<OfferType, OfferTypeSpec> = {
  SALE: {
    description: 'Standard sale offer',
    productPreview: {
      showSaleName: true,
      showDaysLeft: true,
      displayText: null,
      pricePrefix: null,
      priceSuffix: null,
      priceCalculation: null,
    },
    form: {
      requiresEndDate: true,
      requiresPrefix: false,
      requiresSuffix: false,
      usesUnitValueInsteadOfPercentage: false,
    },
  },
  EVERYDAY_COUPONS: {
    description: 'Static everyday offer',
    productPreview: {
      showSaleName: false,
      showDaysLeft: false,
      displayText: 'ADMIN_TEXT',
      pricePrefix: null,
      priceSuffix: null,
      priceCalculation: null,
    },
    form: {
      requiresEndDate: false,
      requiresPrefix: false,
      requiresSuffix: false,
      usesUnitValueInsteadOfPercentage: false,
    },
  },
  SALE_EXTRA_OFFERS: {
    description: 'Sale + extra discount offer',
    productPreview: {
      showSaleName: false,
      showDaysLeft: false,
      displayText: null,
      pricePrefix: 'GET_AT_PRICE',
      priceSuffix: 'ADMIN_TEXT',
      priceCalculation: 'FLAT_OR_PERCENT',
    },
    form: {
      requiresEndDate: false,
      requiresPrefix: false,
      requiresSuffix: true,
      usesUnitValueInsteadOfPercentage: false,
    },
  },
  COUPONS: {
    description: 'Standard coupon offer',
    productPreview: {
      showSaleName: false,
      showDaysLeft: false,
      displayText: null,
      pricePrefix: 'GET_AT_PRICE',
      priceSuffix: 'ADMIN_TEXT',
      priceCalculation: 'FLAT_OR_PERCENT',
    },
    form: {
      requiresEndDate: false,
      requiresPrefix: true,
      requiresSuffix: true,
      usesUnitValueInsteadOfPercentage: false,
    },
  },
  TIERED_COUPONS: {
    description: 'Tier-based coupon offer',
    productPreview: {
      showSaleName: false,
      showDaysLeft: false,
      displayText: null,
      pricePrefix: 'GET_AT_PRICE',
      priceSuffix: 'ADMIN_TEXT',
      priceCalculation: 'TIER_DYNAMIC',
    },
    form: {
      requiresEndDate: false,
      requiresPrefix: true,
      requiresSuffix: true,
      usesUnitValueInsteadOfPercentage: true,
    },
  },
};
